import React from "react";
import { Helmet } from "react-helmet-async";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import CartSection from "../components/CartSection";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";

const CartPage = () => {
  return (
    <>
      <Helmet>
        <title>Cart | Awaneez</title>
      </Helmet>

      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#2694e9" />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* CartSection */}
      <CartSection />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default CartPage;
